import { TRICK_PAUSE_MS } from "@app/rules";

/** The collect animation (`--animate-collect` in the ui tokens). */
export const COLLECT_MS = 800;

/**
 * The won trick rests first: the last card lands and is seen before the four gather
 * (the server keeps the trick on the table for TRICK_PAUSE_MS for exactly that). Before
 * 13 Sept 2026 the collect began at once and a bot's last card never showed.
 */
export const REST_MS = TRICK_PAUSE_MS - COLLECT_MS;

export type TrickStage = "rest" | "collecting" | "gone";

/**
 * Where a won trick is `elapsedMs` after it was first seen: lying as played, being
 * collected, or gone. Once gone it never lies on the table again, whatever the clock:
 * the server lifts the cards after its pause plus the network, and drawing them in that
 * gap flew four cards back onto the table (owner, 13 Sept 2026). A trick that was not
 * resting when first seen (a reload during the next trick) is already gone. Pure.
 */
export function trickStage(elapsedMs: number, seenResting: boolean): TrickStage {
  if (!seenResting) return "gone";
  if (elapsedMs < REST_MS) return "rest";
  return elapsedMs < REST_MS + COLLECT_MS ? "collecting" : "gone";
}
